import { lazy } from "react";
import { Route, Switch } from "react-router-dom";

const Playground10DemoPagePage = lazy(
  () => import("../../workspace/gk/playground-1-0-demo-page")
);

const SkillTestComparePage = lazy(
  () => import("../../workspace/gk/skill-test-compare/Page")
);

const ComboboxPage = lazy(() => import("../../pages/ComboboxPage"));
const ProductTourPage = lazy(() => import("../../pages/ProductTour"));
const V2ToolbarPage = lazy(() => import("../../pages/V2ToolbarPage"));

export function GabeKelleyRoutes() {
  return (
    <Switch>
      <Route path="/gk/combobox" component={ComboboxPage} />
      <Route
        path="/gk/skill-test-compare"
        component={SkillTestComparePage}
      />
      <Route
        path="/gk/playground-1-0-demo-page"
        component={Playground10DemoPagePage}
      />
      <Route path="/gk/product-tour" component={ProductTourPage} />
      <Route path="/gk/v2-toolbar" component={V2ToolbarPage} />
    </Switch>
  );
}

export const slug = "gk";
